import { default as _91_46_46_46slug_934zxpMU9i9VMeta } from "/home/runner/work/web/web/website/pages/[...slug].vue?macro=true";
import { default as _91member_name_93qSOvHu9nivMeta } from "/home/runner/work/web/web/website/pages/about/[member_name].vue?macro=true";
import { default as index7qtBRK7LqtMeta } from "/home/runner/work/web/web/website/pages/about/index.vue?macro=true";
import { default as chat_45inspector5JZWL4yRhMMeta } from "/home/runner/work/web/web/website/pages/admin/chat-inspector.vue?macro=true";
import { default as embed_45statusRuc3KOenWVMeta } from "/home/runner/work/web/web/website/pages/admin/embed-status.vue?macro=true";
import { default as global_45search_45test1uakMMcRlgMeta } from "/home/runner/work/web/web/website/pages/admin/global-search-test.vue?macro=true";
import { default as indexxevAc3HkoJMeta } from "/home/runner/work/web/web/website/pages/admin/index.vue?macro=true";
import { default as kb_45embeddingIMFdlI25XaMeta } from "/home/runner/work/web/web/website/pages/admin/kb-embedding.vue?macro=true";
import { default as location_45explorervNrHD4g7yiMeta } from "/home/runner/work/web/web/website/pages/admin/location-explorer.vue?macro=true";
import { default as migration_45status8kSEeFzTkgMeta } from "/home/runner/work/web/web/website/pages/admin/migration-status.vue?macro=true";
import { default as create3ZPAyfvEflMeta } from "/home/runner/work/web/web/website/pages/admin/product/create.vue?macro=true";
import { default as _91id_93Mkc1p5sWiqMeta } from "/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue?macro=true";
import { default as indexgToullx7t6Meta } from "/home/runner/work/web/web/website/pages/admin/product/index.vue?macro=true";
import { default as user_45managementIQpyTYxRkkMeta } from "/home/runner/work/web/web/website/pages/admin/user-management.vue?macro=true";
import { default as agentS9nvaD9OwBMeta } from "/home/runner/work/web/web/website/pages/agent.vue?macro=true";
import { default as businessuNhUqwQQd5Meta } from "/home/runner/work/web/web/website/pages/ai/business.vue?macro=true";
import { default as indexgYyUJg6qY4Meta } from "/home/runner/work/web/web/website/pages/ai/index.vue?macro=true";
import { default as loginyWg2L2WyIKMeta } from "/home/runner/work/web/web/website/pages/ai/login.vue?macro=true";
import { default as password_45recoverygu6vZLrfMkMeta } from "/home/runner/work/web/web/website/pages/ai/password-recovery.vue?macro=true";
import { default as semanticSearch6xvAWiyb2FMeta } from "/home/runner/work/web/web/website/pages/ai/semanticSearch.vue?macro=true";
import { default as signupc9wiCDy4jwMeta } from "/home/runner/work/web/web/website/pages/ai/signup.vue?macro=true";
import { default as test_45searchdONsS6cP6cMeta } from "/home/runner/work/web/web/website/pages/ai/test-search.vue?macro=true";
import { default as allCMSPagesw1GigKqRZZMeta } from "/home/runner/work/web/web/website/pages/allCMSPages.vue?macro=true";
import { default as companyNexcbDNtVuMeta } from "/home/runner/work/web/web/website/pages/company.vue?macro=true";
import { default as contactsBKQbc7B0FvMeta } from "/home/runner/work/web/web/website/pages/contacts.vue?macro=true";
import { default as cookiestX38G8rclKMeta } from "/home/runner/work/web/web/website/pages/cookies.vue?macro=true";
import { default as destinations71BH5OaJmYMeta } from "/home/runner/work/web/web/website/pages/destinations.vue?macro=true";
import { default as faqFqzXk9qs6NMeta } from "/home/runner/work/web/web/website/pages/faq.vue?macro=true";
import { default as _91_46_46_46slug_93bdOMelzv50Meta } from "/home/runner/work/web/web/website/pages/forward/[...slug].vue?macro=true";
import { default as indexVQ0IiLQsuoMeta } from "/home/runner/work/web/web/website/pages/index.vue?macro=true";
import { default as _91product_id_93eCy0tsA6adMeta } from "/home/runner/work/web/web/website/pages/p/[product_id].vue?macro=true";
import { default as list_45your_45experienceJQb4vgkk4RMeta } from "/home/runner/work/web/web/website/pages/partner/list-your-experience.vue?macro=true";
import { default as privacySNlEVUx5gLMeta } from "/home/runner/work/web/web/website/pages/privacy.vue?macro=true";
import { default as _91category_name_93EdvJ8yRomvMeta } from "/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue?macro=true";
import { default as _91identity_name_93NB9KIyrG6FMeta } from "/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue?macro=true";
import { default as mapWVAnvYY61yMeta } from "/home/runner/work/web/web/website/pages/s/[city_n]/map.vue?macro=true";
import { default as _91tag_name_93za2RghP8BZMeta } from "/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue?macro=true";
import { default as _91city_name_93KeiAIi8x5JMeta } from "/home/runner/work/web/web/website/pages/s/[city_name].vue?macro=true";
import { default as search8AQXWRA7JvMeta } from "/home/runner/work/web/web/website/pages/search.vue?macro=true";
import { default as terms_45of_45serviceexlwU7x0o1Meta } from "/home/runner/work/web/web/website/pages/terms-of-service.vue?macro=true";
import { default as test_45oauthTA33HFaPV1Meta } from "/home/runner/work/web/web/website/pages/test-oauth.vue?macro=true";
import { default as component_45stubUn5MK1ysIRMeta } from "/home/runner/work/web/web/website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubUn5MK1ysIR } from "/home/runner/work/web/web/website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___it",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___de",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___es",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___en",
    path: "/about-us/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___fr",
    path: "/a-propos-de/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___it",
    path: "/chi-siamo/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___de",
    path: "/ueber-uns/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___es",
    path: "/acerca-de/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___pt",
    path: "/pt/sobre-nos/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about-member_name___nl",
    path: "/nl/over-ons/:member_name()",
    component: () => import("/home/runner/work/web/web/website/pages/about/[member_name].vue").then(m => m.default || m)
  },
  {
    name: "about___en",
    path: "/about-us",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___fr",
    path: "/a-propos-de",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___it",
    path: "/chi-siamo",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___de",
    path: "/ueber-uns",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___es",
    path: "/acerca-de",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___pt",
    path: "/pt/sobre-nos",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "about___nl",
    path: "/nl/over-ons",
    component: () => import("/home/runner/work/web/web/website/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___en",
    path: "/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___fr",
    path: "/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___it",
    path: "/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___de",
    path: "/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___es",
    path: "/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___pt",
    path: "/pt/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-chat-inspector___nl",
    path: "/nl/admin/chat-inspector",
    meta: chat_45inspector5JZWL4yRhMMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/chat-inspector.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___en",
    path: "/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___fr",
    path: "/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___it",
    path: "/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___de",
    path: "/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___es",
    path: "/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___pt",
    path: "/pt/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-embed-status___nl",
    path: "/nl/admin/embed-status",
    meta: embed_45statusRuc3KOenWVMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/embed-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___en",
    path: "/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___fr",
    path: "/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___it",
    path: "/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___de",
    path: "/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___es",
    path: "/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___pt",
    path: "/pt/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin-global-search-test___nl",
    path: "/nl/admin/global-search-test",
    meta: global_45search_45test1uakMMcRlgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/global-search-test.vue").then(m => m.default || m)
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___fr",
    path: "/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___it",
    path: "/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___de",
    path: "/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___es",
    path: "/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___pt",
    path: "/pt/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin___nl",
    path: "/nl/admin",
    meta: indexxevAc3HkoJMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___en",
    path: "/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___fr",
    path: "/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___it",
    path: "/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___de",
    path: "/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___es",
    path: "/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___pt",
    path: "/pt/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-kb-embedding___nl",
    path: "/nl/admin/kb-embedding",
    meta: kb_45embeddingIMFdlI25XaMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/kb-embedding.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___en",
    path: "/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___fr",
    path: "/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___it",
    path: "/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___de",
    path: "/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___es",
    path: "/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___pt",
    path: "/pt/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-location-explorer___nl",
    path: "/nl/admin/location-explorer",
    meta: location_45explorervNrHD4g7yiMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/location-explorer.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___en",
    path: "/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___fr",
    path: "/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___it",
    path: "/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___de",
    path: "/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___es",
    path: "/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___pt",
    path: "/pt/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-migration-status___nl",
    path: "/nl/admin/migration-status",
    meta: migration_45status8kSEeFzTkgMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/migration-status.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___en",
    path: "/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___fr",
    path: "/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___it",
    path: "/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___de",
    path: "/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___es",
    path: "/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___pt",
    path: "/pt/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-create___nl",
    path: "/nl/admin/product/create",
    meta: create3ZPAyfvEflMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___en",
    path: "/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___fr",
    path: "/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___it",
    path: "/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___de",
    path: "/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___es",
    path: "/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___pt",
    path: "/pt/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product-edit-id___nl",
    path: "/nl/admin/product/edit/:id()",
    meta: _91id_93Mkc1p5sWiqMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "admin-product___en",
    path: "/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___fr",
    path: "/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___it",
    path: "/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___de",
    path: "/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___es",
    path: "/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___pt",
    path: "/pt/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-product___nl",
    path: "/nl/admin/product",
    meta: indexgToullx7t6Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/product/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___en",
    path: "/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___fr",
    path: "/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___it",
    path: "/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___de",
    path: "/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___es",
    path: "/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___pt",
    path: "/pt/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "admin-user-management___nl",
    path: "/nl/admin/user-management",
    meta: user_45managementIQpyTYxRkkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/admin/user-management.vue").then(m => m.default || m)
  },
  {
    name: "agent___en",
    path: "/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___fr",
    path: "/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___it",
    path: "/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___de",
    path: "/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___es",
    path: "/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___pt",
    path: "/pt/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "agent___nl",
    path: "/nl/agent",
    meta: agentS9nvaD9OwBMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/agent.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___en",
    path: "/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___fr",
    path: "/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___it",
    path: "/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___de",
    path: "/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___es",
    path: "/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___pt",
    path: "/pt/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai-business___nl",
    path: "/nl/ai/business",
    meta: businessuNhUqwQQd5Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/business.vue").then(m => m.default || m)
  },
  {
    name: "ai___en",
    path: "/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___fr",
    path: "/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___it",
    path: "/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___de",
    path: "/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___es",
    path: "/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___pt",
    path: "/pt/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai___nl",
    path: "/nl/ai",
    meta: indexgYyUJg6qY4Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/index.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___en",
    path: "/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___fr",
    path: "/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___it",
    path: "/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___de",
    path: "/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___es",
    path: "/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___pt",
    path: "/pt/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-login___nl",
    path: "/nl/ai/login",
    meta: loginyWg2L2WyIKMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/login.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___en",
    path: "/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___fr",
    path: "/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___it",
    path: "/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___de",
    path: "/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___es",
    path: "/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___pt",
    path: "/pt/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-password-recovery___nl",
    path: "/nl/ai/password-recovery",
    meta: password_45recoverygu6vZLrfMkMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/password-recovery.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___en",
    path: "/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___fr",
    path: "/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___it",
    path: "/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___de",
    path: "/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___es",
    path: "/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___pt",
    path: "/pt/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-semanticSearch___nl",
    path: "/nl/ai/semanticSearch",
    meta: semanticSearch6xvAWiyb2FMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/semanticSearch.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___en",
    path: "/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___fr",
    path: "/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___it",
    path: "/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___de",
    path: "/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___es",
    path: "/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___pt",
    path: "/pt/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-signup___nl",
    path: "/nl/ai/signup",
    meta: signupc9wiCDy4jwMeta || {},
    component: () => import("/home/runner/work/web/web/website/pages/ai/signup.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___en",
    path: "/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___fr",
    path: "/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___it",
    path: "/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___de",
    path: "/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___es",
    path: "/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___pt",
    path: "/pt/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "ai-test-search___nl",
    path: "/nl/ai/test-search",
    component: () => import("/home/runner/work/web/web/website/pages/ai/test-search.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___en",
    path: "/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___fr",
    path: "/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___it",
    path: "/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___de",
    path: "/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___es",
    path: "/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___pt",
    path: "/pt/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "allCMSPages___nl",
    path: "/nl/allCMSPages",
    component: () => import("/home/runner/work/web/web/website/pages/allCMSPages.vue").then(m => m.default || m)
  },
  {
    name: "company___en",
    path: "/company-details",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___fr",
    path: "/coordonn%25C3%25A9es-de-la-soci%25C3%25A9t%25C3%25A9",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___it",
    path: "/dati-societari",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___de",
    path: "/impressum",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___es",
    path: "/informaci%25C3%25B3n-de-la-empresa",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___pt",
    path: "/pt/dados-da-empresa",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "company___nl",
    path: "/nl/bedrijfsgegevens",
    component: () => import("/home/runner/work/web/web/website/pages/company.vue").then(m => m.default || m)
  },
  {
    name: "contacts___en",
    path: "/contact-us",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___fr",
    path: "/contactez-nous",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___it",
    path: "/contattaci",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___de",
    path: "/kontaktiere-uns",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___es",
    path: "/contacto",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___pt",
    path: "/pt/contacte-nos",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___nl",
    path: "/nl/contacteer-ons",
    component: () => import("/home/runner/work/web/web/website/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "cookies___en",
    path: "/cookies-policy",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___fr",
    path: "/politique-en-mati%25C3%25A8re-de-cookies",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___it",
    path: "/informativa-sui-cookie",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___de",
    path: "/cookie-richtlinie",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___es",
    path: "/cookie-policy",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___pt",
    path: "/pt/polit%25C3%25ADca-de-cookies",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "cookies___nl",
    path: "/nl/cookiebeleid",
    component: () => import("/home/runner/work/web/web/website/pages/cookies.vue").then(m => m.default || m)
  },
  {
    name: "destinations___en",
    path: "/destinations",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___fr",
    path: "/destinations",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___it",
    path: "/destinazioni",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___de",
    path: "/reiseziele",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___es",
    path: "/destinos",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___pt",
    path: "/pt/destinos",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "destinations___nl",
    path: "/nl/bestemmingen",
    component: () => import("/home/runner/work/web/web/website/pages/destinations.vue").then(m => m.default || m)
  },
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___fr",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___it",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___de",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___es",
    path: "/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___nl",
    path: "/nl/faq",
    component: () => import("/home/runner/work/web/web/website/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___en",
    path: "/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___fr",
    path: "/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___it",
    path: "/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___de",
    path: "/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___es",
    path: "/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___pt",
    path: "/pt/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "forward-slug___nl",
    path: "/nl/forward/:slug(.*)*",
    component: () => import("/home/runner/work/web/web/website/pages/forward/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/home/runner/work/web/web/website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___en",
    path: "/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___fr",
    path: "/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___it",
    path: "/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___de",
    path: "/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___es",
    path: "/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___pt",
    path: "/pt/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "p-product_id___nl",
    path: "/nl/p/:product_id()",
    component: () => import("/home/runner/work/web/web/website/pages/p/[product_id].vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___en",
    path: "/partner/list-your-experience",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___fr",
    path: "/partenaire/publier-une-offre",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___it",
    path: "/partner/aggiungi-la-tua-esperienza",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___de",
    path: "/partner/angebote-inserieren",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___es",
    path: "/asociado/publica-tu-experiencia",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___pt",
    path: "/pt/parceiros/adicionar-experiencias",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "partner-list-your-experience___nl",
    path: "/nl/partner/promoot-jouw-activiteiten",
    component: () => import("/home/runner/work/web/web/website/pages/partner/list-your-experience.vue").then(m => m.default || m)
  },
  {
    name: "privacy___en",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___fr",
    path: "/politique-sur-la-vie-priv%25C3%25A9e",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___it",
    path: "/informativa-sulla-privacy",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___de",
    path: "/datenschutz-bestimmungen",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___es",
    path: "/pol%25C3%25ADtica-de-privacidad",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___pt",
    path: "/pt/polit%25C3%25ADca-de-privicidade",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___nl",
    path: "/nl/privacybeleid",
    component: () => import("/home/runner/work/web/web/website/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___en",
    path: "/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___fr",
    path: "/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___it",
    path: "/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___de",
    path: "/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___es",
    path: "/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___pt",
    path: "/pt/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-c-category_name___nl",
    path: "/nl/s/:city_n()/c/:category_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/c/[category_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___en",
    path: "/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___fr",
    path: "/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___it",
    path: "/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___de",
    path: "/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___es",
    path: "/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___pt",
    path: "/pt/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-i-identity_name___nl",
    path: "/nl/s/:city_n()/i/:identity_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/i/[identity_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___en",
    path: "/s/:city_n()/map",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___fr",
    path: "/s/:city_n()/carte",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___it",
    path: "/s/:city_n()/mappa",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___de",
    path: "/s/:city_n()/karte",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___es",
    path: "/s/:city_n()/mapa",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___pt",
    path: "/pt/s/:city_n()/mapa",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-map___nl",
    path: "/nl/s/:city_n()/kaart",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/map.vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___en",
    path: "/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___fr",
    path: "/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___it",
    path: "/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___de",
    path: "/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___es",
    path: "/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___pt",
    path: "/pt/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_n-t-tag_name___nl",
    path: "/nl/s/:city_n()/t/:tag_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_n]/t/[tag_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___en",
    path: "/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___fr",
    path: "/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___it",
    path: "/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___de",
    path: "/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___es",
    path: "/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___pt",
    path: "/pt/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "s-city_name___nl",
    path: "/nl/s/:city_name()",
    component: () => import("/home/runner/work/web/web/website/pages/s/[city_name].vue").then(m => m.default || m)
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr",
    path: "/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___it",
    path: "/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___de",
    path: "/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___es",
    path: "/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___pt",
    path: "/pt/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___nl",
    path: "/nl/search",
    component: () => import("/home/runner/work/web/web/website/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___en",
    path: "/terms-of-service",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___fr",
    path: "/conditions-d%2527utilisation",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___it",
    path: "/termini-di-servizio",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___de",
    path: "/nutzungsbedingungen",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___es",
    path: "/condiciones-del-servicio",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___pt",
    path: "/pt/termos-de-servi%25C3%25A7o",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___nl",
    path: "/nl/voorwaarden",
    component: () => import("/home/runner/work/web/web/website/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___en",
    path: "/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___fr",
    path: "/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___it",
    path: "/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___de",
    path: "/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___es",
    path: "/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___pt",
    path: "/pt/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: "test-oauth___nl",
    path: "/nl/test-oauth",
    meta: test_45oauthTA33HFaPV1Meta || {},
    component: () => import("/home/runner/work/web/web/website/pages/test-oauth.vue").then(m => m.default || m)
  },
  {
    name: component_45stubUn5MK1ysIRMeta?.name,
    path: "/terms/",
    component: component_45stubUn5MK1ysIR
  },
  {
    name: component_45stubUn5MK1ysIRMeta?.name,
    path: "/blog/post-sitemap.xml",
    component: component_45stubUn5MK1ysIR
  }
]